import Axios from "axios";
import * as serviceURL from "./service-url";

//rak beneficiary table list
export const getAllRakBeneficiaryList = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.post(serviceURL.getAllRakBeneficiaryList, request, {
    headers: headers,
    params: params,
  });
};
//drodowns
export const getDropdownTypeList = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.get(serviceURL.getDropdownTypeList, {
    headers: headers,
    params: params,
  });
};
export const getDropdownStatusList = (
  request = {},
  headers = {},
  params = {}
) => {
  return Axios.get(serviceURL.getDropdownStatusList, {
    headers: headers,
    params: params,
  });
};
export const getDropdownCountryList = (type, headers = {}, params = {}) => {
  return Axios.get(
    `${serviceURL.getDropdownCountryList}${type ? type : "POPULAR"}`,
    {
      headers: headers,
      params: params,
    }
  );
};
// bank details
export const getBankDetailByBeneficiaryId = (
  id = null,
  headers = {},
  params = {}
) => {
  return Axios.get(serviceURL.getBankDetailByBeneficiaryId + id, {
    headers: headers,
    params: params,
  });
};
// send conformation
export const getConformationDetails = (id) => {
  return Axios.put(serviceURL.getConformationDetails + id);
};

//? APPROVE BENEFICIARY
export const approveBeneficiaryById = (id) => {
  return Axios.put(serviceURL.approveBeneficiary + id);
};
//? SENT CONFIRMATION - BENEFICIARY
export const sentConfirmationById = (id) => {
  return Axios.put(serviceURL.sentConfirmationById + id, {});
};

export const updateTransactionStatus = (id) => {
  return Axios.get(serviceURL.updateTransactionStatus + id);
};

export const transactionRevrseService = (referenceNumber) => {
  return Axios.patch(serviceURL.transactionRevrse(referenceNumber), {});
};

export const transactionMarkSuccessService = (referenceNumber) => {
  return Axios.patch(serviceURL.transactionMarkSuccess(referenceNumber), {});
};
